import {
    SketchPointBoxSelectionRole,
    SketchPointKind,
} from '../ISketchObject';
import type {SketchPointObject} from '../SketchPointObject';
import {isSketchPointEntitySelectable} from './isSketchPointEntitySelectable';

/**
 * 判断草图点是否允许进入框选候选集。
 *
 * 设计说明：
 * 1. 普通草图点始终允许框选，保持既有交互；
 * 2. 普通曲线控制点继续排除，避免框选误选大量内部控制点；
 * 3. 具有显式专用角色的控制点由各业务创建方声明框选能力，
 *    统一候选层不再耦合矩形或倒角等具体业务角色。
 * 4. 会话临时捕捉点不属于实体，无论点类型和框选角色如何都必须排除。
 *
 * @param point 草图点对象。
 * @returns 是否允许进入框选候选集。
 */
export function isSketchPointBoxSelectable(point: SketchPointObject): boolean {
    return isSketchPointEntitySelectable(point)
        && (point.pointKind !== SketchPointKind.ControlPoint
            || point.boxSelectionRole !== SketchPointBoxSelectionRole.Default);
}
